module.exports = __webpack_public_path__ + "static/media/fastPanel.ed2b2653.jpg";